import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router";

const CopyRight = () => {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-[#5AE65E]">
      <div className="w-full max-w-[1536px] m-auto mx-auto flex flex-col items-center text-center px-6 py-4 text-[#1a2b13] text-sm font-medium md:flex-row md:items-center md:justify-between md:text-left">
        <div>
          @2025 <FormattedMessage id="LANDINGPAGE.FOOTER.COPYRIGHT_RESERVED" />.
        </div>
        <div className="mt-1 md:mt-0">
          <a
            onClick={() => navigate("/privacy-policy")}
            className="hover:underline cursor-pointer"
          >
            <FormattedMessage id="LANDINGPAGE.FOOTER.PRIVACY_POLICY" />
          </a>{" "}
          |
          <a
            onClick={() => navigate("/terms-and-conditions")}
            className="hover:underline ml-1 cursor-pointer"
          >
            <FormattedMessage id="LANDINGPAGE.FOOTER.TERMS_AND_CONDITION" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default CopyRight;
